import {
  FETCH_INVOICEDETAILS_REQUEST,
  FETCH_INVOICEDETAILS_SUCCESS,
  FETCH_INVOICEDETAILS_FAILURE,
} from "./invoiceDetailsTypes";
import api from "../../utils/Api";

export const fetchInvoiceDetailsRequest = () => {
  return {
    type: FETCH_INVOICEDETAILS_REQUEST,
  };
};

export const fetchInvoiceDetailsSuccess = (transactionDetails) => {
  return {
    type: FETCH_INVOICEDETAILS_SUCCESS,
    payload: transactionDetails,
  };
};

export const fetchInvoiceDetailsFailure = (error) => {
  return {
    type: FETCH_INVOICEDETAILS_FAILURE,
    payload: error,
  };
};

export const fetchInvoiceDetails = (invoice_id) => {
  const headers = {
    Authorization:
      "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
  };
  return async (dispatch) => {
    dispatch(fetchInvoiceDetailsRequest());
    try {
      const response = await api.get(
        "payment/invoice/detail/fetch?invoice_id=" + invoice_id,
        {
          headers: headers,
        }
      );
      const invoiceDetails = response.data.data;
     // console.log("**************invoiceDetails", invoiceDetails);
      dispatch(fetchInvoiceDetailsSuccess(invoiceDetails));
    } catch (error) {
      console.log("Redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchInvoiceDetailsFailure(errorMsg));
    }
  };
};
